




import marked from 'marked';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getOrString } from '@/utilities/helpers';

marked.setOptions({
	sanitize: true,
	smartLists: true,
});

@Component({
	name: 'MarkdownText',
	props: {
		content: String,
	},
})
export default class MarkdownText extends Vue {
	public content!: string;

	public get markdownContent(): string {
		return marked(this.content || this.slotContent);
	}

	public get slotContent(): string {
		return getOrString('default.0.text', this.$slots).trim();
	}
}
